var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"flex flex-column align-items-center ribbon-button text-center px-2"},'div',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"rounded-square-button ribbon-button-icon text-white"},[_c('i',{class:_vm.icon})]),_vm._v(" "),_c('div',{staticClass:"mt-2 text-center text-white"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }